import { Case } from "@repo/provider-network";

/**
 * Finds the newest case from an array of patient visits based on created_at timestamp
 * @param patientVisits - Array of Case objects with created_at field
 * @returns Object with newest Case and its timestamp, or { newestCase: null, caseTimestamp: null }
 */
export const reduceToNewestCase = (
  patientVisits: Case[]
): { newestCase: Case | null; caseTimestamp: number | null } => {
  if (!patientVisits || patientVisits.length === 0) {
    return { newestCase: null, caseTimestamp: null };
  }

  // Filter out cases without created_at timestamps
  const validCases = patientVisits.filter((visit) => visit.created_at);

  if (validCases.length === 0) {
    return { newestCase: null, caseTimestamp: null };
  }

  const newestCase = validCases.reduce((newest, current) => {
    const currentDate = new Date(current.created_at!);
    const newestDate = new Date(newest.created_at!);

    return currentDate > newestDate ? current : newest;
  });

  const caseTimestamp = new Date(newestCase.created_at!).getTime();

  return { newestCase, caseTimestamp };
};
